// "KPI tablosu (Excel)" — proje belgeleri listesindeki her belge kartı için ikincil bağlantı
// (M16 T22, C5): belgenin donmuş `kpi_snapshot` manifestinden üretilen xlsx'i indirir
// (`GET /documents/:id/kpi.xlsx`). TODO-KPI-13: belge DTO'sundaki `hasKpiSnapshot` bayrağıyla
// yalnız manifestli belgede render edilir (ProjectDetail koşulu) — "bu belgede KPI tablosu yok"
// satırı kalktı; sunucu yine de 404 `no_kpi_snapshot` dönerse genel hata metni gösterilir.
// Bağlama: ProjectDetail belge kartının altına `<DocumentKpiLink documentId={d.id} />`; kart kendisi
// <button> olduğu için bu bileşen kartın DIŞINA (kart sarmalayıcı div içine) konmalı — iç içe
// interactive öğe (axe nested-interactive) olmasın.

import { useState } from "react";
import { ApiError } from "../../api/client";
import { downloadDocumentKpiExcel } from "../../api/kpi-export";

export const DOCUMENT_KPI_COPY = {
  label: "KPI tablosu (Excel)",
  busy: "Hazırlanıyor…",
  title: "Rapor üretildiği andaki KPI tablosu — formüllü Excel",
  failed: "KPI tablosu indirilemedi",
} as const;

export function DocumentKpiLink({ documentId }: { documentId: string }): JSX.Element {
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState<string | null>(null);

  async function handleClick(): Promise<void> {
    setBusy(true);
    setNote(null);
    try {
      await downloadDocumentKpiExcel(documentId);
    } catch (err) {
      setNote(err instanceof ApiError ? err.message : DOCUMENT_KPI_COPY.failed);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex items-center gap-2 mt-1" style={{ fontSize: "0.78rem" }}>
      <button
        type="button"
        onClick={() => void handleClick()}
        disabled={busy}
        title={DOCUMENT_KPI_COPY.title}
        aria-busy={busy}
        className="underline disabled:opacity-50"
        style={{ color: "var(--color-primary)", background: "none", border: "none", padding: 0 }}
      >
        📊 {busy ? DOCUMENT_KPI_COPY.busy : DOCUMENT_KPI_COPY.label}
      </button>
      {note ? (
        <span role="status" style={{ color: "var(--color-text-3)" }}>
          {note}
        </span>
      ) : null}
    </div>
  );
}
